module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-row', [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "xxl",
      "variant": "light"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n        ")], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "8"
    }
  }, [_c('h5', {
    staticClass: "page-title mb-2"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.$route.name) + " ")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "8"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    ref: "search",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search Assignment"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', {
    staticClass: "mr-1"
  }, [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [(_vm.activeUserPreference) ? _c('label', [_c('b', [_vm._v(" Created User Filter")])]) : _vm._e(), _vm._v(" "), (_vm.activeUserPreference) ? _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "addedUserFilter",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Created User"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.userFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "userFilter", $$v)
      },
      expression: "Filter.userFilter"
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "pressed": _vm.activeButtonBranch,
      "variant": _vm.activeButtonBranch ? 'success' : 'danger'
    },
    on: {
      "click": function($event) {
        _vm.BranchBtnFilter(_vm.activeButtonBranch)
      }
    },
    model: {
      value: (_vm.activeButtonBranch),
      callback: function($$v) {
        _vm.activeButtonBranch = $$v
      },
      expression: "activeButtonBranch"
    }
  }, [_vm._v("Branch\n            " + _vm._s(_vm.activeButtonBranch ? " Filter On" : " Filter Off"))]), _vm._v(" "), (_vm.$sessionsStorage.get('userId')) ? _c('userBasedClient', {
    attrs: {
      "PMC_title": 'User Summary - ' + _vm.$sessionsStorage.get('employeeName'),
      "PMC_USERID": _vm.Filter.userFilter,
      "PMC_USERNAME": _vm.$sessionsStorage.get('nameUser'),
      "PMC_USERDESIG": _vm.$sessionsStorage.get('designation'),
      "PMC_BranchClientPre": _vm.$sessionsStorage.get('branchclientPre'),
      "PMC_TransportTypePre": _vm.$sessionsStorage.get('transportTypePre'),
      "PMC_UserEmpName": _vm.$sessionsStorage.get('employeeName'),
      "PMC_UserEmpCode": _vm.$sessionsStorage.get('employeeCode')
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('h5', [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.JOBList.length) + " Entries")]) : _vm._e()])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [(_vm.JOBList.length > 0) ? _c('b-button', {
    staticClass: "pull-right mb-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export As Excel' ? true : false,
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.getReports('checkCCExpJobPendency', 'Export As Excel')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ExcelBtnName) + "\n            "), (_vm.ExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right mb-1",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.closeAssignmentPendencyList
    }
  }, [_vm._v("Close Assignment Pendency")]), _vm._v(" "), _c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "5",
      "total-rows": _vm.JOBList.length,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 row table-wrapper-scroll-x my-custom-scrollbar"
  }, [_c('b-table', {
    staticClass: "table-background position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "fields": _vm.columnMain,
      "items": _vm.JOBList,
      "per-page": _vm.perPage,
      "current-page": _vm.currentPage,
      "filter": _vm.filter
    },
    on: {
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "Branch",
      fn: function(row1) {
        return [_c('tr', {
          class: {
            blink: _vm.isBlinking(row1.item)
          }
        }, [_c('td', [_c('div', {
          class: {
            'blink-circle': _vm.shouldBlink(row1.item)
          }
        })])]), _vm._v(" "), _c('span', [_vm._v(_vm._s(row1.item.Branch))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Manifest : " + row1.item.is_manifestation_status))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Billing : ")]), _vm._v(" "), (row1.item.TallyBillingSeries) ? _c('div', {
          staticClass: "text-left"
        }, [(row1.item.TallyBillingSeries) ? _c('div', _vm._l((row1.item.TallyBillingSeries.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_c('b', [_vm._v(_vm._s(item1 == "" ? "-------" : item1))])]), _c('br')], 1)
        })) : _vm._e()]) : _c('div', {
          staticClass: "text-left"
        }, [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1), _vm._v(" "), (row1.item.allModuleId) ? _c('JobWisePaymentsDetails', {
          attrs: {
            "allModuleId": Number(row1.item.allModuleId),
            "JobNo": row1.item.JOBNO
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row1.item.JOBNO,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.JOBNO,
            "PMC_JOBDATE": row1.item.JOBDate,
            "PMC_JOBTYPE": row1.item.JOBTYPE,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.clientName,
            "PMC_Sline": row1.item.shippingLine
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('AssignmentSplitMergeSummary', {
          attrs: {
            "PMC_title": 'Assignment Split/Merge/Move Summary Job No - ' + row1.item.JOBNO,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.JOBNO,
            "PMC_JOBDATE": row1.item.JOBDate,
            "PMC_JOBTYPE": row1.item.JOBTYPE,
            "PMC_AgentType": '',
            "PMC_Client": row1.item.clientName,
            "PMC_Sline": row1.item.shippingLine
          }
        }) : _vm._e()]
      }
    }, {
      key: "billingTypeMain",
      fn: function(row2) {
        return [_c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Billing Type : " + row2.item.is_billingType_status)), _c('br')]), _vm._v(" "), (
          row2.item.is_billingType_status == 'Local' ||
          row2.item.is_billingType_status == 'Both'
        ) ? _c('span', [_vm._v(_vm._s("Local : " +
          (row2.item.billingTypeMain == "Local Billing" ? "Done" : "Pending"))), _c('br')]) : _vm._e(), _vm._v(" "), (
          row2.item.is_billingType_status == 'Overseas' ||
          row2.item.is_billingType_status == 'Both'
        ) ? _c('span', [_vm._v(_vm._s("Overseas : " +
          (row2.item.is_manifestation_status == "Yes" ? "Done" : "Pending"))), _c('br')]) : _vm._e(), _c('br'), _vm._v(" "), _c('span', {
          class: row2.item.oe_payment_date_first == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s("Sline Req date : " +
          row2.item.oe_payment_date_first))]), _c('br')]
      }
    }, {
      key: "JOBNO",
      fn: function(row3) {
        return [_c('tr', {
          class: {
            blink: _vm.isBlinking(row3.item)
          },
          on: {
            "click": function($event) {
              _vm.goPage(row3.item)
            }
          }
        }, [_c('td', [_c('span', [_vm._v(_vm._s("JOBNO : " + row3.item.JOBNO))]), _c('br')])]), _vm._v(" "), _c('span', [_vm._v(_vm._s("JOBDate : " + row3.item.JOBDate))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("RaisedBy : " + row3.item.RaisedBy))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("MBLNO : " + row3.item.MBLNO))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("HBLNO : " + row3.item.HBLNO))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Tot Cont : " + row3.item.ContainerCount))]), _c('br')]
      }
    }, {
      key: "clientName",
      fn: function(row4) {
        return [_c('span', [_vm._v(_vm._s(row4.item.clientName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Exporter : " + row4.item.Exp_clientName))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("Importer : " + row4.item.Imp_clientName))])]
      }
    }, {
      key: "shippingLine",
      fn: function(row5) {
        return [_c('span', [_vm._v(_vm._s(row5.item.shippingLine))])]
      }
    }, {
      key: "POR",
      fn: function(row6) {
        return [_c('span', [_vm._v(_vm._s("POR : " + row6.item.POR))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("POL : " + row6.item.POL))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s("POD : " + row6.item.POD))]), _vm._v(" "), _c('span', [_vm._v(_vm._s("FPOD : " + row6.item.FPOD))])]
      }
    }, {
      key: "leoDate",
      fn: function(row10) {
        return [_c('span', {
          class: row10.item.leoDate == 'Pending' ? 'error' : '',
          on: {
            "click": function($event) {
              _vm.goLeoHandPage(row10.item)
            }
          }
        }, [_vm._v(_vm._s(row10.item.leoDate))])]
      }
    }, {
      key: "cc_handoverDate",
      fn: function(row11) {
        return [_c('span', {
          class: row11.item.cc_handoverDate == 'Pending' ? 'error' : '',
          on: {
            "click": function($event) {
              _vm.goLeoHandPage(row11.item)
            }
          }
        }, [_vm._v(_vm._s(row11.item.cc_handoverDate))])]
      }
    }, {
      key: "cc_paymentDate",
      fn: function(row12) {
        return [_c('span', {
          class: row12.item.cc_paymentDate == 'Pending' ? 'error' : '',
          on: {
            "click": function($event) {
              _vm.goLeoHandPage(row12.item)
            }
          }
        }, [_vm._v(_vm._s(row12.item.cc_paymentDate))])]
      }
    }, {
      key: "SOB",
      fn: function(row14) {
        return [_c('span', {
          class: row14.item.SOB == 'Pending' ? 'error' : ''
        }, [_vm._v(_vm._s("P44 : " + row14.item.SOB))])]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d35f8bc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Pendency/ccExpPendency.vue
// module id = 2542
// module chunks = 0